const $ = window.jQuery;
import 'slick-carousel';

$(() => {
  const $slider = $('.shop-cards__slider').first();

  if (!$slider.length) {
    return;
  }

  $slider.slick({
    slidesToShow: 1,
    infinite: false,
    arrows: false,
  });
});
